import { Colors, Services } from '@sigma-frontend-libs/commons'

import { icons, moderationColors, moderationIcons } from '@/utils'

import sticker from '@/components/sticker'
import actions from '@/components/templates/service/item/actions'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderTitle(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value,
        label: this.getTranslate(`${Services.patterns}.labels.title`),
        icon: moderationIcons[this.value.moderation],
        color: moderationColors[this.value.moderation],
        iconTooltip: this.getTranslate(`misc.moderation.${this.value.moderation}`),
        service: Services.patterns,
        copy: true
      }
    }
  )
}
function renderSendername(h) {
  if (this.viewport.size.width > 550) {
    return h(
      sticker,
      {
        props: {
          value: this.value.payload.sender,
          label: this.getTranslate(`${Services.patterns}.labels.sendername`),
          iconSVG: this.value.type,
          color: this.value.type,
          iconTooltip: this.getTranslate(`${Services.sendings}.types.${this.value.type}`),
          copy: true
        }
      }
    )
  }
}
function renderOwner(h) {
  if (this.viewport.size.width > 720) {
    return h(
      owner,
      {
        props: {
          value: this.value
        }
      }
    )
  }
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.patterns}-item__info`]: true,
        [`${Services.patterns}-item__info--admin`]: this.canGetUsersAsResellerUp
      }
    },
    [
      renderTitle.call(this, h),
      renderSendername.call(this, h),
      renderOwner.call(this, h)
    ]
  )
}

function renderTextContent(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value.payload.text,
        label: this.getTranslate(`${Services.patterns}.labels.text`),
        icon: icons.text_snippet,
        color: Colors.grey,
        copy: true
      }
    }
  )
}
function renderText(h) {
  if (this.viewport.size.width > 1280) {
    return h(
      'div',
      {
        class: `${Services.patterns}-item__text`
      },
      [ renderTextContent.call(this, h) ]
    )
  }
}

function renderActions(h) {
  return h(
    actions,
    {
      props: {
        value: this.value,
        service: Services.patterns
      }
    }
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        'service-template-item': true,
        [`${Services.patterns}-item`]: true,
        'hover-parent hover-parent--opacity': this.viewport.breakpoint.mdUp
      }
    },
    [
      renderInfo.call(this, h),
      renderText.call(this, h),
      renderActions.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
